import type { AudienceCard, BundleItem, FaqItem, PainPoint, Review, Step } from '../types/artTherapy';
export const heroTrust = ['🔒 Biztonságos fizetés', '📧 Azonnali hozzáférés', '🎁 6 ajándék bónusz', '📱 100% digitális'];
export const stats = [{
  value: '150+',
  label: "GYAKORLAT"
}, {
  value: '6',
  label: "INGYENES BÓNUSZ"
}, {
  value: "10",
  label: "PERC NAPONTA"
}, {
  value: "0",
  label: "SZÜKSÉGES RAJZTUDÁS"
}];
export const painPoints: PainPoint[] = [{
  kind: 'no',
  text: 'Az elméd nem áll le. Ugyanazokat a gondolatokat forgatod újra és újra, és este kimerülten, azzal az érzéssel zuhansz az ágyba, hogy semmi fontosat nem csináltál.'
}, {
  kind: 'yes',
  text: 'A vezetett tevékenységek segítenek lelassítani, és néhány perc nyugalmat adni magadnak.'
}, {
  kind: 'no',
  text: 'Mindent magadban tartasz. Rengeteg mindent érzel, de amikor megpróbálod elmondani, mi történik benned, egyszerűen nem jönnek a szavak.'
}, {
  kind: 'yes',
  text: 'Színekkel, kollázzsal és írással kifejezheted, amit érzel, anélkül, hogy mindent szavakkal kellene elmagyaráznod.'
}, {
  kind: 'no',
  text: 'Órákat töltesz a telefonodon, hogy kikapcsolj. De amikor leteszed, a gondok még mindig ott vannak.'
}, {
  kind: 'yes',
  text: 'Egy egyszerű kreatív tevékenység valódi nyugalmat ad, távol a képernyőktől.'
}];
export const painClosing = {
  lead: 'A művészetterápia teret ad annak, amit érzel.',
  lines: ['Nem kell tudnod rajzolni. Csak egy lap, néhány szín és 10 perc magadra.']
};
export const audienceCards: AudienceCard[] = [{
  tone: 'peach',
  emoji: '🌿',
  tag: 'Neked',
  title: 'A saját jóllétedért',
  points: ['Sok érzelmet szeretnél kifejezni, de néha nem találod a szavakat.', 'Nem tudsz rajzolni? Nincs szükséged művészi tehetségre.', 'Szeretnél néhány perc nyugalmat, távol a mindennapi gondoktól.', 'Kiválasztasz egy tevékenységet, és otthon, a saját tempódban elvégzed.']
}, {
  tone: 'lavender',
  emoji: '🎨',
  tag: 'A munkádhoz',
  title: 'Azoknak, akiket támogatsz',
  points: ['Ideális pszichológusoknak, terapeutáknak, pedagógusoknak, coachoknak és szociális munkásoknak.', 'Több mint 150 azonnal használható tevékenység egyéni vagy csoportos foglalkozásokhoz.', 'Alkalmazási útmutatót tartalmaz a gyakorlatok használatához és értelmezéséhez (5. bónusz).', 'Kreatív eszközök azokra a pillanatokra, amikor a veled szemben ülő ember sok mindent érez, de nem tudja, hogyan fejezze ki.']
}];
export const steps: Step[] = [{
  title: 'Válaszd ki a hozzád illő tevékenységet',
  text: 'Fedezz fel több mint 150 kreatív gyakorlatot, és válaszd azt, amire épp szükséged van.'
}, {
  title: 'Készítsd elő, ami már kéznél van',
  text: 'Egy papírlap, néhány színes ceruza vagy más egyszerű eszköz elég.'
}, {
  title: 'Kövesd a lépéseket, nyomás nélkül',
  text: 'Hagyd, hogy az utasítások vezessenek, és élvezd a folyamatot, anélkül, hogy a tökéletes eredmény miatt aggódnál.'
}, {
  title: 'Állj meg egy pillanatra, és figyeld meg, mit érzel',
  text: 'Dolgozz a saját tempódban, és adj magadnak egy pillanatot az elmélyülésre.'
}];
export const stepTags = ['Nincs szükség tapasztalatra', 'Könnyű elkezdeni', 'Otthon vagy foglalkozásokon', '100% digitális'];
export const manualFeatures = ['📄 Digitális PDF formátum', '🖨️ Nyomtatható feladatlapok', '✍️ Lépésről lépésre útmutató', '🎨 Nincs szükség tapasztalatra'];
/** A kézikönyv oldalainak címe és rövid leírása — ugyanabban a sorrendben, mint a data/media.ts manualPages listája. */
export const manualPageCaptions = [
  { title: 'Gyógyuló szív', text: 'Színezd sötét színekkel, ami fáj, aztán meleg színekkel azt, ami gyógyul.' },
  { title: 'Megújító eső', text: 'Minden esőcseppbe írj valamit, amit szeretnél elengedni.' },
  { title: 'A szándék magjai', text: 'Minden magba írj egy szándékot, amelyet szeretnél elültetni az életedben.' },
  { title: 'Személyes átalakulás', text: 'Az egyik szárnyra azt írd, amit elengedsz, a másikra azt, ami jön.' },
  { title: 'A nyugalom üvege', text: 'Zárd az üvegbe, ami nyugtalanít, és színezd lágy árnyalatokkal.' },
  { title: 'A bőség mandalája', text: 'Minden részébe írj valamit, amiért ma hálás vagy.' },
  { title: 'A hála tükre', text: 'Írj a tükörbe három dolgot, amiért hálás vagy önmagadnak.' },
  { title: 'A szabadság madara', text: 'A szárnyaira írd, amitől szabadnak érzed magad.' },
  { title: 'Az élet hullámai', text: 'A hullámokra írd azokat, akik melletted állnak.' },
  { title: 'Üzenet a jövőbeli önmagamnak', text: 'Írj egy rövid levelet annak, aki egy év múlva leszel.' },
];
export const mainProduct: BundleItem = {
  badge: '📘 A fő termék',
  title: 'Művészetterápiás Kézikönyv — Több mint 150 vezetett tevékenység',
  description: 'Kreatív rajzolási, kollázs- és önreflexiós gyakorlatok, amelyek segítenek felfedezni és kifejezni az érzelmeidet. Könnyen használható otthon vagy másokkal végzett munkában.'
};
export const bonuses: BundleItem[] = [{
  badge: '🎁 1. bónusz',
  title: '17 kreatív tevékenység az érzelmek kifejezésére',
  value: '2 990 Ft',
  description: '17 további gyakorlat, hogy új módokat fedezz fel a kifejezésre, az önreflexióra és a saját érzelmeidhez való kapcsolódásra.'
}, {
  badge: '🎁 2. bónusz',
  title: '20 technika az önbecsülés erősítésére',
  value: '2 490 Ft',
  description: 'Gyakorlati feladatok és vezetett reflexiók, hogy felfedezd a személyes erősségeidet, és pozitívabb énképet alakíts ki.'
}, {
  badge: '🎁 3. bónusz',
  title: 'Kártyák a félelmek legyőzéséhez',
  value: '2 490 Ft',
  description: 'Kérdések és önreflexiós gyakorlatok, amelyek segítenek feltárni és jobban megérteni a félelmeidet, és új nézőpontokat felfedezni.'
}, {
  badge: '🎁 4. bónusz',
  title: 'Az elakadások feloldása',
  value: '2 990 Ft',
  description: 'Gyakorlati útmutató a gyakori érzelmi elakadások felismeréséhez és kreatív továbblépési lehetőségek felfedezéséhez.'
}, {
  badge: '🎁 5. bónusz',
  title: 'Alkalmazási útmutató a gyakorlatok használatához és értelmezéséhez',
  value: '2 490 Ft',
  description: 'Világos utasítások a tevékenységek használatához és a tapasztalatok feldolgozásához, akár magadnak, akár azoknak, akiket támogatsz.'
}, {
  badge: '🎁 6. bónusz',
  title: '60 kártya a bátorságért és az önbizalomért',
  value: '2 990 Ft',
  description: 'Bátorító üzenetek és pozitív reflexiók, hogy lépésről lépésre erősítsd az önbizalmadat és a bátorságodat.'
}];
export const reviews: Review[] = [{
  name: 'Emily C.',
  quote: '„Attól tartottam, hogy túl bonyolult lesz, de már az első feladatnál tudtam, mit kell csinálnom. Tetszik, hogy az útmutató érthető, és nem kell hozzá semmilyen művészeti tudás."'
}, {
  name: 'Sophie B.',
  quote: '„Örülök, hogy nem csak rajzolós feladatok vannak benne. Többféle kreatív ötletet találtam, bár néhánynál szívesen láttam volna még egy-két példát. Ettől függetlenül hasznos gyűjtemény."'
}, {
  name: 'Olivia P.',
  quote: '„Egy esős hétvégén próbáltam ki először, amikor semmihez sem volt kedvem. Végül annyira belemerültem az egyik feladatba, hogy másnap is elővettem a kézikönyvet."'
}, {
  name: 'Grace M.',
  quote: '„Régebben mindig félbehagytam a kreatív dolgokat, mert nem tetszett a végeredmény. Itt végre nem az számít, mennyire szép, amit készítek. Ez sokkal felszabadítóbbá teszi az egészet."'
}, {
  name: 'Charlotte W.',
  quote: '„A feladatok szépen vannak összeállítva, és jó, hogy a hangulatomhoz választhatok közülük. Természetesen nem mindegyik fogott meg ugyanúgy, de összességében elégedett vagyok a vásárlással."'
}, {
  name: 'Hannah T.',
  quote: '„Egy nehéz munkanap után próbáltam ki az egyik színezős feladatot. Jólesett egy kicsit csendben lenni, és csak arra figyelni, ami éppen a papíron történik."'
}, {
  name: 'Rebecca A.',
  quote: '„Pont valami olyasmit kerestem, amit esténként a kanapén ülve is elővehetek a közösségi oldalak görgetése helyett. Most egy rövid kreatív feladattal sokkal kellemesebben zárom a napot."'
}, {
  name: 'Jessica M.',
  quote: '„Egyszerű elkezdeni, és nincs szükség különleges eszközökre. Néhány gyakorlatot már többször is megcsináltam, mert mindig más gondolatokat hoz elő belőlem."'
}];
export const faqItems: FaqItem[] = [{
  question: 'Tudnom kell rajzolni vagy festeni?',
  answer: 'Egyáltalán nem! Nem kell semmi tökéleteset alkotnod. Az a fontos, hogy a színeket, a formákat és a kreativitásodat arra használd, hogy kifejezd, amit érzel. Akkor is elkezdheted, ha semmilyen művészi tapasztalatod nincs.'
}, {
  question: 'Milyen eszközökre van szükségem?',
  answer: 'Elkezdheted papírral, színes ceruzákkal, filcekkel, magazinokkal vagy más egyszerű eszközökkel, amelyek már otthon vannak. Nincs szükség különleges felszerelésre.'
}, {
  question: 'Használhatom a kézikönyvet a munkámban is?',
  answer: 'Igen! A tevékenységeket használhatod magadnak és a másokkal végzett munkában is. Hasznos eszközök pszichológusoknak, terapeutáknak, pedagógusoknak, coachoknak és foglalkozásvezetőknek, egyéni vagy csoportos foglalkozásokon. Az 5. bónusz lépésről lépésre segít a használatukban.'
}, {
  question: 'Ez terápia vagy orvosi kezelés?',
  answer: 'Ez a kreatív önkifejezés és az érzelmi jóllét eszköze. Nem helyettesíti az orvosi vagy pszichológiai kezelést, és nem szolgál betegségek diagnosztizálására vagy kezelésére.'
}, {
  question: 'Mennyi időre van szükségem naponta?',
  answer: 'Már néhány perccel is elkezdheted. Válaszd ki a hozzád illő tevékenységet, és szánj rá annyi időt, amennyire szükséged van, sietség és nyomás nélkül.'
}, {
  question: 'Pontosan mit kapok?',
  answer: 'Megkapod a Művészetterápiás Kézikönyvet több mint 150 vezetett tevékenységgel, valamint 6 exkluzív digitális bónuszt. Ezen felül ingyen megkapod a 2. kiadást is, további 100 új művészetterápiás tevékenységgel.'
}, {
  question: 'Hogyan kapom meg az anyagokat?',
  answer: 'Minden 100% digitális. A fizetés megerősítése után e-mailben kapsz hozzáférést az anyagaidhoz. Bármikor letöltheted és kinyomtathatod őket, amikor szükséged van rájuk.'
}, {
  question: 'Van garancia?',
  answer: 'Igen! 30 napos elégedettségi garanciát kapsz. A saját tempódban fedezheted fel az anyagokat, és ha nem felelnek meg az elvárásaidnak, ezen időszak alatt visszakérheted a vételárat.'
}];